<!-- Header -->
<div class="d-flex flex-wrap flex-stack mb-6">
  <div>
    <h3 class="fw-bold my-2">{{ 'horses.title' | translate }}</h3>
    <p class="text-muted fs-6 mb-0">{{ 'horses.subtitle' | translate }}</p>
  </div>
  <div class="d-flex flex-wrap my-2">
    <app-button
      [variant]="'primary'"
      [label]="'horses.addHorse' | translate"
      [iconClass]="'fa fa-plus'"
      (clicked)="openModal()"
    />
  </div>
</div>
<!-- Empty State -->
@if (!loading && (!horses || horses.length === 0)) {
  <div class="card mb-9">
    <div class="empty-state">
      <div class="empty-state-icon">
        <i class="fa-solid fa-horse"></i>
      </div>
      <h4>{{ 'horses.noHorses' | translate }}</h4>
      <p>{{ 'horses.noHorsesHint' | translate }}</p>
      <app-button
        [variant]="'primary'"
        [label]="'horses.addHorse' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openModal()"
      />
    </div>
  </div>
}

<!-- Horse Cards -->
@if (horses && horses.length > 0) {
  <div class="row g-6 mb-6 g-xl-9 mb-xl-9" [class.opacity-50]="loading" [class.pointer-events-none]="loading">
    @for (horse of horses; track horse.horse_id) {
      <div class="col-md-4">
        <app-horse-card
          [horse]="horse"
          (editHorseClick)="openEditModal($event)"
          (deleteHorseClick)="deleteHorse($event)"
        />
      </div>
    }
  </div>
}


